import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-t-open-question',
  templateUrl: './t-open-question.component.html',
  styleUrls: ['./t-open-question.component.css']
})
export class TOpenQuestionComponent extends GeneralTeacherComponent {

  question: string = "";

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute) {
    super(topicService, activatedRoute);
  }

  ngOnInit() {
    super.ngOnInit();
    this.type = "openQuestion";
    this.title = this.get("openQuestion");
  }

  reset() {
    super.reset();
    this.title = this.get("openQuestion");
    this.question = "";
  }

  generateDefinition(): any {
    let definition: any = {};
    definition.title = this.title;
    definition.description = this.description;
    definition.type = this.type;
    definition.level = 2;
    definition.image = "./assets/images/openQuestion_white.png";
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    definition.typespecifics = {};
    definition.typespecifics.question = this.question;

    definition.key = "dataRepresentation%openQuestion%";
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    let questionS = "";
    let typeSpecS = "";
    if (this.question != undefined && this.question != "") {
      questionS = this.question;
    } else {
      questionS = this.description;
    }
    definition.key = definition.key.concat(questionS, "%", typeSpecS, "%", this.description);
    this.id = definition.id;
    return definition;
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.question = this.configuration.typespecifics.question;

  }




}
